import { defineComponent as k, ref as f, computed as i, provide as t, watch as h, onBeforeUnmount as w, createElementBlock as E, openBlock as P, mergeProps as N, unref as o, renderSlot as A, createVNode as L } from "vue";
import { classesFromBreakpointProps as O } from "../../breakpoints.js";
import { useWindowSize as V } from "@vueuse/core";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import I from "./ToolbarLabelGroupContent.vue2.js";
import "./common.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
const G = Symbol("ToolbarToggleExpandedKey"), H = Symbol("ToolbarClearFilterButtonTextKey"), M = Symbol("ToolbarShowClearFiltersButtonKey"), R = Symbol("ToolbarClearAllFiltersKey"), W = Symbol("ToolbarUpdateNumberFiltersKey"), $ = Symbol("ToolbarExpandedKey"), j = Symbol("ToolbarLabelGroupContentRefKey"), z = Symbol("ToolbarNumberOfFiltersKey"), _ = /* @__PURE__ */ k({
  name: "PfToolbar",
  __name: "Toolbar",
  props: {
    clearFiltersButtonText: { default: "Clear all filters" },
    collapseListedFiltersBreakpoint: { default: "lg" },
    expanded: { type: Boolean, default: void 0 },
    fullHeight: { type: Boolean },
    static: { type: Boolean },
    sticky: { type: Boolean },
    colorVariant: { default: "default" },
    noPadding: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    inset: {},
    insetSm: {},
    insetMd: {},
    insetLg: {},
    insetXl: {},
    inset2xl: {}
  },
  emits: ["update:expanded", "clear-all-filters"],
  setup(T, { emit: g }) {
    const a = T, v = U({ id: a.ouiaId, safe: a.ouiaSafe }), p = g, c = f(!1), d = i(() => !a.expanded && a.expanded !== !1), n = i({
      get() {
        return d.value ? c.value : a.expanded ?? !1;
      },
      set(e) {
        d.value && (c.value = e), p("update:expanded", e);
      }
    });
    t($, n);
    const s = f(null);
    t(j, s);
    const { width: B } = V(), m = f({}), u = i(() => Object.values(m.value).reduce((e, r) => e + r, 0));
    t(z, u);
    const F = i(() => O(a, ["inset"], l)), b = i(() => u.value > 0);
    t(M, b), t(G, K), t(H, a.clearFiltersButtonText), t(R, y), t(W, C), h(B, () => {
      d.value && x();
    }), w(() => {
      s.value && (s.value = null);
    });
    function x() {
      n.value = !1;
    }
    function K() {
      n.value = !n.value;
    }
    function C(e, r) {
      m.value[e] = r;
    }
    function y() {
      p("clear-all-filters");
    }
    return (e, r) => (P(), E("div", N(o(v), {
      class: [o(l).toolbar, F.value, {
        [o(l).modifiers.fullHeight]: e.fullHeight,
        [o(l).modifiers.static]: e.static,
        [o(l).modifiers.sticky]: e.sticky,
        [o(l).modifiers.primary]: e.colorVariant === "primary",
        [o(l).modifiers.secondary]: e.colorVariant === "secondary",
        [o(l).modifiers.noBackground]: e.colorVariant === "no-background",
        [o(l).modifiers.noPadding]: e.noPadding
      }]
    }), [
      A(e.$slots, "default"),
      L(I, {
        expanded: n.value,
        "show-clear-filters-button": b.value,
        "clear-filters-button-text": e.clearFiltersButtonText,
        "number-of-filters": u.value,
        "collapse-listed-filters-breakpoint": e.collapseListedFiltersBreakpoint,
        onClearAllFilters: y,
        onMounted: r[0] || (r[0] = (S) => s.value = S)
      }, null, 8, ["expanded", "show-clear-filters-button", "clear-filters-button-text", "number-of-filters", "collapse-listed-filters-breakpoint"])
    ], 16));
  }
});
export {
  R as ToolbarClearAllFiltersKey,
  H as ToolbarClearFilterButtonTextKey,
  $ as ToolbarExpandedKey,
  j as ToolbarLabelGroupContentRefKey,
  z as ToolbarNumberOfFiltersKey,
  M as ToolbarShowClearFiltersButtonKey,
  G as ToolbarToggleExpandedKey,
  W as ToolbarUpdateNumberFiltersKey,
  _ as default
};
